import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";
import { SITE_HEADER_HEIGHT, SITE_SCROLL_MARGIN, SITE_SCROLL_SPACE } from "../../shared/constants";

export const RightContainer = styled(Box)(() =>
    css({
        gridArea: "right",
        paddingX: ["space0", "space0", "space200"],
        position: "sticky",
        top: SITE_SCROLL_MARGIN,
        right: 0,
        maxHeight: `calc(100vh - ${SITE_HEADER_HEIGHT} - ${SITE_SCROLL_SPACE})`,
        overflowX: "auto",
        height: "max-content"
    })
);
